import React from "react";
import { Box, Heading, Text, VStack } from "@chakra-ui/react";
import UiButton from "./UiButton";

export default function UiEmptyState({
  icon,
  title,
  description,
  actionLabel,
  onAction,
}) {
  return (
    <VStack spacing={3} align="center" textAlign="center" py={8}>
      {icon ? <Box fontSize="3xl">{icon}</Box> : null}
      {title ? <Heading size="sm">{title}</Heading> : null}
      {description ? <Text color="text.muted">{description}</Text> : null}
      {actionLabel ? (
        <UiButton size="sm" onClick={onAction}>
          {actionLabel}
        </UiButton>
      ) : null}
    </VStack>
  );
}
